import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { environment } from 'src/environment/environment';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { ExtensionsService } from '../../_services/extensions.service';
import { Queue } from '../../_types/queue';
import { QueueMember } from '../../_types/queue-member';

@Component({
    selector: 'app-queue-member-add',
    templateUrl: './queue-member-add.component.html',
    styleUrls: ['./queue-member-add.component.css'],
    standalone: false
})
export class QueueMemberAddComponent implements OnInit {
  public queue!: Queue;
  public existingMembers: QueueMember[] = [];
  public extensions: any[] = [];
  public selectedExtension: any = null;
  public saving = false;

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private extensionsService: ExtensionsService,
    private usersService: UsersService,
    private messageService: MessageService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.queue = this.config.data.queue;
    this.existingMembers = this.config.data.existingMembers || [];
    this.loadExtensions();
  }

  async loadExtensions() {
    const extParams: IParamsCollection = {
      page: { number: 1, size: 1000 },
      sort: ['exten']
    };
    const usrParams: IParamsCollection = {
      page: { number: 1, size: 1000 }
    };
    const [extResponse, usrResponse] = await Promise.all([
      firstValueFrom(this.extensionsService.all(extParams)),
      firstValueFrom(this.usersService.all(usrParams))
    ]);

    const users: any[] = usrResponse.data;
    const existingInterfaces = this.existingMembers.map(m => m.interface);

    this.extensions = extResponse.data
      .filter((ext: any) => {
        if (!ext.exten || !ext.userId) return false;
        const user = users.find((u: any) => u.id == ext.userId);
        if (!user) return false;
        return !existingInterfaces.includes('PJSIP/' + user.userName);
      })
      .map((ext: any) => {
        const user = users.find((u: any) => u.id == ext.userId);
        return {
          label: ext.exten + (ext.description ? ' - ' + ext.description : ''),
          value: { ...ext, userName: user?.userName }
        };
      });
  }

  save() {
    if (!this.selectedExtension) {
      this.messageService.add({ severity: 'warn', detail: 'Seleccione una extensión' });
      return;
    }

    if (!this.selectedExtension.userName) {
      this.messageService.add({ severity: 'error', detail: 'La extensión no tiene usuario asociado' });
      return;
    }

    const body = {
      data: {
        type: 'queueMembers',
        attributes: {
          queueName: this.queue.name,
          interface: 'PJSIP/' + this.selectedExtension.userName,
          paused: 0
        },
        relationships: {
          queue: {
            data: { type: 'queues', id: this.queue.id }
          }
        }
      }
    };

    this.saving = true;
    this.http.post(environment.api_gw + 'Voip/queueMembers', body, {
      headers: { 'Content-Type': 'application/vnd.api+json' }
    }).subscribe({
      next: () => {
        this.saving = false;
        this.messageService.add({ severity: 'success', detail: 'Miembro añadido' });
        this.dynamicDialogRef.close(true);
      },
      error: (error: any) => {
        this.saving = false;
        this.messageService.add({ severity: 'error', detail: error?.error?.errors?.[0]?.title || error?.error?.title || 'Error al añadir miembro' });
      }
    });
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
